import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadUserById,
    setUserProfileEdit,
    setUserProfileReloadEdit,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const EditProfile = () => {
    const profile = useSelector((state: StoreType) => state.userProfile.profileEdit)
    const reloadEdit = useSelector((state: StoreType) => state.userProfile.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadUserById(userData.userId).then((res) => {
            setLoadState(IDLE)
            dispatch(setUserProfileEdit(res))
            dispatch(setUserProfileReloadEdit(false))
            setTimeout(() => {
                dispatch(setUserProfileReloadEdit(true))
            }, 0)
        })
    }, [])

    if (!profile) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editProfile}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form profile={profile} />
                }
                {
                    reloadEdit
                    && <Form profile={profile} />
                }
            </PageContent>
        </Container>
    )
}
export default EditProfile
